import _regenerator from "/app/src/Web/InternetBranch/node_modules/@babel/runtime-corejs2/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/src/Web/InternetBranch/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import MobileHeader from "./MobileHeader.vue";
import onlineBranchApi from "@/api/crm/onlinebranch";
import ChangePassword from "@/components/ChangePassword";
export default {
  components: {
    "mobile-header": MobileHeader,
    ChangePassword: ChangePassword
  },
  data: function data() {
    return {
      showBusy: true,
      showOk: false,
      customerId: null,
      isHidden: false,
      dialogVisible: false,
      str: null,
      firstName: null,
      lastName: null,
      forceChangePassowrd: false
    };
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return this.getCustomerInfo();
          case 1:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  mounted: function mounted() {},
  methods: {
    openDialog: function openDialog() {
      this.dialogVisible = true;
    },
    logout: function logout() {
      var _this = this;
      this.$store.dispatch("LogOut").then(function () {
        _this.$router.push("/");
        // In order to re-instantiate the vue-router object to avoid bugs
      });
    },
    getCustomerInfo: function getCustomerInfo() {
      var _this2 = this;
      this.showBusy = true;
      return onlineBranchApi.getCustomerInfo().then(function (v) {
        _this2.firstName = v.data.firstName;
        _this2.lastName = v.data.lastName;
      }).catch(function () {}).finally(function () {
        _this2.showBusy = false;
      });
    },
    handle: function handle() {
      this.isHidden = false;
    },
    close: function close() {
      this.dialogVisible = false;
    }
  }
};